import * as types from "../../mutationTypes";
import orderService from "services/orderService";

const actions = {
  async setFilterDate ({ dispatch, commit }, date) {
    await commit(types.ORDER_DATE_FILTER, {
      date: date
    });
  },
  async setFilterDateRange ({ commit }, dates) {
    await commit(types.ORDER_DATE_RANGE_FILTER, {
      dateFrom: dates.dateFrom,
      dateTo: dates.dateTo
    });
  },
  async findByDate ({ dispatch, commit, state }, date) {
    if (date) {
      await dispatch('setFilterDate', date);
    } else if (!state.filterDate) {
      throw new Error('Missing filter date.');
    }
    await commit(types.ORDER_LIST, { items: [] });
    dispatch('app/loadingDataEnable', 'orders', {root: true});
    const orders = await orderService.findByDate(state.filterDate);
    await commit(types.ORDER_LIST, {
      items: orders || []
    });
    dispatch('app/loadingDataDisable', 'orders', {root: true});
  },
  async findByDateRange ({ dispatch, commit, state }, dates) {
    if (!dates.dateFrom || ! dates.dateTo) {
      throw new Error('Missing filter date range.');
    }
    dispatch('app/loadingDataEnable', 'orders', {root: true});
    await dispatch('setFilterDateRange', dates);
    const orders = await orderService.findByDateRange(state.filterDateFrom, state.filterDateTo);
    await commit(types.ORDER_LIST, {
      items: orders || []
    });
    dispatch('app/loadingDataDisable', 'orders', {root: true});
  },
  async create ({ dispatch }, order) {
    let newOrder = await orderService.create(order);
    if (newOrder) {
      await dispatch('findByDate');
      return true;
    } else {
      return false;
    }
  },
  async update ({ dispatch }, order) {
    let updatedOrder = await orderService.update(order);
    if (updatedOrder) {
      await dispatch('findByDate');
      return true;
    } else {
      return false;
    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/order/orderActions.js